var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" 正面、右側面、左側面の画像を下記のURLからアップロードしていただけますか。 ")]),_c('v-container',{staticClass:"slieImage"},[_c('img',{staticStyle:{"height":"440px","width":"100%"},attrs:{"src":_vm.images}}),_c('p',[_vm._v("画像は正面、右側面、左側面の3種類をアップロードしてください")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }